import React from 'react';

export const ExpandIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4264 5.33333C15.4264 4.8731 15.7995 4.5 16.2597 4.5H19.593C20.0533 4.5 20.4264 4.8731 20.4264 5.33333L20.4264 8.66667C20.4264 9.1269 20.0533 9.5 19.593 9.5C19.1328 9.5 18.7597 9.1269 18.7597 8.66667L18.7597 7.25312L15.1432 10.5339C14.8023 10.8431 14.2753 10.8174 13.9661 10.4766C13.6568 10.1357 13.6825 9.60868 14.0234 9.29946L17.4768 6.16667H16.2597C15.7995 6.16667 15.4264 5.79357 15.4264 5.33333ZM11.033 13.5228C11.3425 13.8633 11.3174 14.3904 10.9769 14.7L7.53018 17.8333H8.75944C9.21968 17.8333 9.59277 18.2064 9.59277 18.6667C9.59277 19.1269 9.21968 19.5 8.75944 19.5H5.42611C4.96587 19.5 4.59277 19.1269 4.59277 18.6667L4.59277 15.3333C4.59277 14.8731 4.96587 14.5 5.42611 14.5C5.88634 14.5 6.25944 14.8731 6.25944 15.3333L6.25944 16.7361L9.85578 13.4667C10.1963 13.1571 10.7234 13.1822 11.033 13.5228Z"
        fill="#5A6877"
      />
    </svg>
  );
};

export default ExpandIcon;
